/**
 * Default sermon outline used both when starting a brand-new sermon
 * and when a loaded draft has no saved outline.
 */
export const DEFAULT_OUTLINE = [
  { id: 1, title: 'Introduction', content: '' },
  { id: 2, title: 'Point 1', content: '' },
  { id: 3, title: 'Point 2', content: '' },
  { id: 4, title: 'Conclusion', content: '' },
];

export const cloneDefaultOutline = () =>
  DEFAULT_OUTLINE.map((p) => ({ ...p }));
